import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'
import FileNameIconBase from 'components/file-name-icon'

export const FileNameIcon = styled(FileNameIconBase)`
    ${svgStroke()}
`

export const FileName = styled.div`
    display: flex;
    align-items: center;
    column-gap: 16px;
`